// extracted by mini-css-extract-plugin
export default {"requiredLabel":"SWUserForm_requiredLabel__0ERm2"};